import { Link } from "react-router-dom";
import { founders, team } from "@/pages/team/data";

export default function Founders() {
  return (
    <section id="founders" className="py-20 md:py-28 bg-brand-800 text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <div className="flex justify-center">
          <div className="px-6 py-2 border border-white/40 rounded-md text-white/90 tracking-widest text-sm">專業團隊</div>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
          {founders.map((f) => (
            <article key={f.name} className="bg-brand-700/40 border border-white/10 rounded-lg p-6 md:p-8">
              <div className="flex items-baseline flex-wrap gap-x-4 gap-y-1 mb-6">
                <h3 className="text-2xl md:text-3xl font-semibold">{f.name}</h3>
                <span className="text-brand-100/80 text-sm">{f.title}</span>
              </div>
              <div className="flex flex-col md:flex-row gap-6">
                <div className="w-full h-60 sm:h-72 md:w-40 md:h-52 shrink-0">
                  <img src={f.photo} alt={f.name} className="w-full h-full object-cover object-[50%_30%] md:object-top rounded-md" />
                </div>
                <div className="space-y-3 text-sm leading-relaxed text-white/85">
                  {f.bio.map((p, i) => (
                    <p key={i} className="flex gap-2">
                      <i className="ri-arrow-right-s-fill text-brand-300 mt-0.5"></i>
                      <span>{p}</span>
                    </p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-10">
          {team.map((t) => (
            <article key={t.name} className="bg-brand-700/40 border border-white/10 rounded-lg p-6 md:p-8">
              <div className="flex items-baseline flex-wrap gap-x-3 gap-y-1 mb-2">
                <h3 className="font-serif italic text-2xl md:text-3xl">{t.name}</h3>
                <span className="text-brand-100/80 text-sm">{t.tags}</span>
              </div>
              <div className="border-t border-dashed border-white/25 my-4"></div>
              <div className="flex flex-col md:flex-row gap-6">
                {t.photo && (
                  <div className="w-full h-60 sm:h-72 md:w-40 md:h-52 shrink-0">
                    <img src={t.photo} alt={t.name} className="w-full h-full object-cover object-[50%_30%] md:object-top rounded-md" />
                  </div>
                )}
                <ul className="space-y-2 text-sm text-white/85 leading-relaxed">
                  {t.bullets.map((b, i) => (
                    <li key={i} className="flex gap-2">
                      <i className="ri-checkbox-blank-circle-fill text-[8px] mt-2 text-brand-300"></i>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 flex justify-center gap-4">
          <Link
            to="/team"
            className="px-8 py-3 rounded-md bg-brand-500 hover:bg-brand-400 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
          >
            查看完整團隊
          </Link>
          <Link
            to="/courses"
            className="px-8 py-3 rounded-md border border-white/40 hover:bg-white/10 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
          >
            更多服務
          </Link>
        </div>
      </div>
    </section>
  );
}